.overflowContainer {
    display: flex;
	justify-content: center;
    margin-left: auto;
	width: 64px;
}

.fileNameAndState {
    display: flex;
    align-items: center;
    gap: 10px;
}

.dropzone {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 30px;
	border: 3px dashed var(--hps-gray);
}

.dropzone.disabled {
	opacity: 0.6;
}

.dropzone p {
	margin: 0;
}

.dropzoneDragActive {
	background-color: var(--hps-light-gray);
}

.uploadProgressContainer {
	display: flex;
}

.uploadProgressText {
	width: 180px;
}

.uploadProgressBar {
	display: flex;
	align-items: center;
	flex-grow: 1;
	min-width: 10px;
}
